module.exports = __webpack_public_path__ + "7faf1d234b361d9cfa568c4b1d32f58b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-narrative.png
// module id = 3643
// module chunks = 0